import React, { useMemo } from 'react';

import { Button, type ButtonProps } from '@change/ds-core-ui/next';

import { useI18n } from '@change-corgi/core/react/i18n';

type Props = {
	amount: number;
	amountLocalized: string;
	isSelected: boolean;
	onClick: (value: { amount: number; amountLocalized: string }) => void;
} & ButtonProps;

export function AmountButton({ amount, amountLocalized, isSelected, onClick, ...rest }: Props): React.JSX.Element {
	const { translate } = useI18n();

	const value = useMemo(() => {
		return amount ? amountLocalized : translate('corgi.membership.awareness.other_amount_label');
	}, [amount, amountLocalized, translate]);
	return (
		<div
			className={`flex flex-1 rounded-lg ${isSelected ? 'bg-[linear-gradient(275deg,#0139BC_2.93%,#4BAEFF_96.39%)] p-[2px]' : ''}`}
		>
			<Button
				className={`${isSelected ? 'rounded-[7px] bg-gradient-to-b from-[#F0F7FF] to-blue-100 before:border-transparent' : ''} bg-fill-inverse-strong flex-1`}
				variant="secondary-solid"
				size="small"
				type="button"
				data-testid="membership-awareness-form-amount-button"
				onClick={() => onClick({ amount, amountLocalized })}
				{...rest}
			>
				{value}
			</Button>
		</div>
	);
}
